import { SortAndPage } from "@/models/ui/sortAndPage";
import { http } from "../api";
import {
  ListPlanForTerminalResponseSchema,
  ListTerminalResponseSchema,
} from "./types";

/**
 * Calls the list terminals endpoint to get a list of all the terminals
 * @returns A list of terminals with shortened details
 */
async function getTerminals() {
  const terminalResponse = await http.get("/v1/terminals");
  return ListTerminalResponseSchema.parse(terminalResponse.data);
}

/**
 * Returns all of the plans association with a terminal
 * @param terminalId The id of the terminal to fetch plans for
 * @returns A list of all the plans associated with a terminal
 */
async function getPlansForTerminal(
  terminalId: number,
  pagination: SortAndPage,
) {
  const planResponse = await http.get(`/v1/terminals/${terminalId}/plans`, {
    params: {
      offset: pagination.offset,
      limit: pagination.limit,
      sortBy: pagination.sortBy,
      sortDirection: pagination.sortDirection,
      filter: pagination.search,
    },
  });
  return ListPlanForTerminalResponseSchema.parse(planResponse.data);
}

export default {
  getTerminals,
  getPlansForTerminal,
};
